import React from 'react';
import { joinClass } from '../helpers/component';
import Card from './Card';

const CardGroup = ({
  children,
  withCard,
  className,
}) => {
  const makeItem = (child, index) => child && (
    <div className="card-group__item" key={index}>
      {withCard && <Card>{child}</Card>}
      {!withCard && child}
    </div>
  );

  return (
    <div className={joinClass('card-group', className)}>
      {Array.isArray(children)
        && children.map((child, index) => makeItem(child, index))}
      {!Array.isArray(children) && makeItem(children)}
    </div>
  );
};

export default CardGroup;
